import React from "react";
import SEO from '../services/SEO';
import useAuth from '../hooks/useAuth';
import { useTranslation } from "react-i18next";
import TLSEtiquetas from "../components/TLSEtiquetas/TLSEtiquetas";

const TLSEtiquetasPage = () => {

	window.scrollTo(0, 0);

	const { t, i18n: {changeLanguage, language} } = useTranslation();
	const { auth } = useAuth();

	return(
		<div>
			<SEO title="TLS Engenharia" description="Descubra soluções inovadoras em software e tecnologia que impulsionam negócios e simplificam processos. Acesse e explore as últimas tendências tecnológicas!" />
			<h2 className="title is-1">TLS Etiquetas</h2>
			<br/>
			<hr/>
			<br/>
			<TLSEtiquetas/>
		</div>
	);
}


export default TLSEtiquetasPage;